import { Namespace, TemplateUsage, Workflow } from 'enums-lib';
import { IActionConfig, IConfigFilter, IWorkflowConfig } from 'interfaces-lib';
import { Section } from './section';

export class WorkflowConfig implements IWorkflowConfig {
  actionConfigs: IActionConfig[];
  clientId: string;
  clientNamespace: Namespace;
  createdBy: string;
  dateCreated: Date;
  dateModified: Date;
  entity: string;
  filters?: IConfigFilter[];
  id: string;
  isPublic: boolean;
  modifiedBy: string;
  name: string;
  namespaces: Namespace[];
  sections: Section[];
  workflow: Workflow;
  useFileAttachmentAsTemplate?: boolean;
  usageTypes?: TemplateUsage[];

  constructor(namespace: Namespace, workflow: Workflow) {
    this.id = null;
    this.clientId = null;
    this.clientNamespace = namespace;
    this.createdBy = null;
    this.dateCreated = new Date();
    this.dateModified = new Date();
    this.entity = null;
    this.isPublic = false;
    this.modifiedBy = null;
    this.name = '';
    this.namespaces = [namespace]; // TODO: how will we use this in future?
    this.sections = [];
    this.workflow = workflow;
    this.actionConfigs = [];
    this.useFileAttachmentAsTemplate = false;
    this.usageTypes = [TemplateUsage.AwesomeDocs];
  }

  static clone(original: IWorkflowConfig): IWorkflowConfig {
    return JSON.parse(JSON.stringify(original));
  }
}
